import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { THEME } from "../../theming/theming";
import { classNames } from "../../utils/classNames";
var SORT_GLYPH_MAP = {
    asc: "menu-up",
    desc: "menu-down",
};
export var TableHeaderCell = function (_a) {
    var sortDirection = _a.sortDirection, title = _a.title, onSort = _a.onSort, sortColumn = _a.sortColumn, headingKey = _a.headingKey;
    var _b = useState(false), showUnsetIcon = _b[0], setShowUnsetIcon = _b[1];
    var classes = useStyles();
    return (React.createElement("div", { role: "button", onMouseEnter: function () { return headingKey !== sortColumn && setShowUnsetIcon(true); }, onMouseLeave: function () { return headingKey !== sortColumn && setShowUnsetIcon(false); }, onClick: function () {
            onSort(headingKey);
            headingKey !== sortColumn && setShowUnsetIcon(false);
        }, onKeyPress: function () {
            onSort(headingKey);
            headingKey !== sortColumn && setShowUnsetIcon(false);
        }, className: classes.button },
        title,
        showUnsetIcon ? (React.createElement("span", { className: classNames("glyphicon glyphicon-menu-up", classes.unset, classes.icon) })) : (sortColumn === headingKey &&
            sortDirection && (React.createElement("span", { className: classNames("glyphicon glyphicon-".concat(SORT_GLYPH_MAP[sortDirection]), classes.icon) })))));
};
var useStyles = createUseStyles({
    button: {
        padding: 5,
        position: "relative",
        paddingRight: 19,
    },
    icon: {
        position: "absolute",
        right: 5,
        top: 7,
    },
    unset: {
        color: THEME.palette.gray.cloud.color,
    },
});
